export enum FOLLOW_UP_DISCOUNT_PREFERENCES {
  Client = "Client",
  Project = "Project"
}
